import React from "react";
import './css/kid.management.scss';
import '../../mui/binkiesCompliments.css';
import { Col, Row } from "react-bootstrap";
import ComplimentsReceived from "../../mui/ComplimentsReceived";
import MostCommentedCreation from "../../mui/MostCommentedCreation";
import Binkies from "../../mui/Binkies";

const DashboardInsights = ({ selectedDependent, showDetailedInsights }) => {
  return (
    showDetailedInsights &&
    <>
      <Row className="myroom-info-wrapper slider-cards short_second_card_row challenges-progress2">
        <Col
          className="myroom-collapse insights-soon">
          <ComplimentsReceived type='Received' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
        <Col
          className="myroom-collapse insights-soon">
          <ComplimentsReceived type='Given' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
      </Row>
      <Row className="myroom-info-wrapper slider-cards short_second_card_row">
        <Col
          className="myroom-collapse insights-soon most-complimented-creation">
          <MostCommentedCreation type='Comment' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
      </Row>
      <Row className="myroom-info-wrapper slider-cards short_second_card_row">
        <Col
          className="myroom-collapse insights-soon">
          <Binkies type='Received' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
        <Col
          className="myroom-collapse insights-soon">
          <Binkies type='Given' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
      </Row>
      <Row className="myroom-info-wrapper slider-cards short_second_card_row">
        <Col
          className="myroom-collapse insights-soon most-complimented-creation">
          <MostCommentedCreation type='Binky' cardClass={"short_second_card"} dependent={selectedDependent} />
        </Col>
      </Row>
    </>
  )
}

export default DashboardInsights;